export class Einheit {
    einheit_id: number;
    bezeichnung: string;
}
